import { QuestionIcon } from '@phosphor-icons/react'
import classNames from 'classnames'
import { TooltipWithHover } from '../tooltip.tsx'
import * as styles from './scope-hierarchy-hint.css.ts'

const LEVELS = [
  { level: 'Organization', reach: 'Applies to all repositories', depthClassName: undefined },
  { level: 'Project', reach: 'Applies to only the assigned repositories', depthClassName: styles.rowLevelDepth1 },
  { level: 'Repository', reach: 'Applies to only that repository', depthClassName: styles.rowLevelDepth2 },
]

/**
 * The help affordance on the Projects page description: a hover card that lays out the three scope
 * levels from broad to narrow and says which one wins.
 */
export const ScopeHierarchyHint: React.FC = () => (
  <TooltipWithHover
    // 360px rather than the 300px default so the longest row holds one line.
    maxWidth={360}
    side="bottom"
    align="start"
    sideOffset={3}
    trigger={
      <button type="button" className={styles.trigger} aria-label="How resolution works">
        <QuestionIcon size={16} weight="regular" aria-hidden />
      </button>
    }
  >
    <div className={styles.card}>
      <span className={styles.heading}>Scope hierarchy</span>
      <span className={styles.lead}>The narrower the scope, the higher its priority.</span>
      {LEVELS.map(({ level, reach, depthClassName }) => (
        <span key={level} className={styles.row}>
          <b className={classNames(styles.rowLevel, depthClassName)}>{level}</b>
          <span className={styles.rowReach}>{reach}</span>
        </span>
      ))}
    </div>
  </TooltipWithHover>
)
